import React, { useState } from 'react';

function Paper({ title, links, authors, journal, date, citation, abstract, interpretationNote }) {
    const [openPanel, setOpenPanel] = useState(null);

    const togglePanel = (panel) => setOpenPanel(openPanel === panel ? null : panel);

    const panels = [
        abstract && { key: 'abstract', label: 'Abstract' },
        citation && { key: 'citation', label: 'Citation' },
        interpretationNote && { key: 'note', label: 'Interpretation Note' },
    ].filter(Boolean);

    const hasLinks = links && links.length > 0;

    return(
        <div className='paper mb-3'>

            <span>
                {title}
            </span>
            <p><b>{journal}</b>{journal && <> </>}{date}{date && <> </>}<em className='authors'>{authors}</em></p>
            {(panels.length > 0 || hasLinks) &&
            <>
                <div className='mt-1'>
                    {panels.map((panel, i) =>
                    <React.Fragment key={panel.key}>
                        {i > 0 && <span className='d-inl'> | </span>}
                        <button
                            type='button'
                            className='btn'
                            onClick={() => togglePanel(panel.key)}
                        >
                            <p className='btn-inner d-inl-bl'>{openPanel === panel.key ? '▾' : '▸'} {panel.label}</p>
                        </button>
                    </React.Fragment>)}
                    {hasLinks && links.map((link, i) => <div key={link.url} className='d-inl'>{(panels.length > 0 || i > 0) && ' | '} <a key={link.url} href={link.url} target='_blank' rel='noreferrer' className='link'>{link.title}</a></div>)}
                </div>
                {openPanel === 'abstract' && <div className='abstract-text'>{abstract}</div>}
                {openPanel === 'citation' && <code className='citation-text'>{citation}</code>}
                {openPanel === 'note' && <div className='abstract-text'>{interpretationNote}</div>}
            </>
            }
        </div>
    );
};

export default Paper;
